<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_register_service_user' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="form" #ngForm="ngForm">
        <div class="p-6" mat-dialog-content>
            <ng-container>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{'label_service_user' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <mat-select (selectionChange)="onChangeDomain($event.value)" formControlName="domainId" placeholder="Kerfi">
                                @for (domain of data.data; track domain) {
                                <mat-option [value]="domain.value"> {{domain.viewValue}} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{'label_username' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <input id="username" [formControlName]="'username'" matInput />
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{ 'label_password' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <input id="password" [formControlName]="'password'" type="password" matInput />
                            @if (form.get('password').hasError('minlength') && !form.hasError('required')) {
                            <mat-error> {{'error_new_password_length' | translate: { passwordMinLength: passwordMinLength } }} </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{ 'label_confirm_password' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <input id="confirmPassword" [formControlName]="'confirmPassword'" type="password" matInput />
                            @if (form.get('confirmPassword').hasError('required') && (form.get('confirmPassword').dirty ||
                            form.get('confirmPassword').touched)) {
                            <mat-error> {{'error_confirm_password' | translate }} </mat-error>
                            } @if (form.get('confirmPassword').hasError('mustMatch') && (form.get('confirmPassword').dirty ||
                            form.get('confirmPassword').touched)) {
                            <mat-error> {{'error_password_match' | translate }} </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <div class="float-left w-100 mt-2">
                <!-- Divider -->
                @if (form.get('agent')?.value) {
                <div class="mt-1 mb-1 border-t"></div>
                }
                <!-- Actions -->
                <div class="flex items-center justify-end mt-2 mb-2">
                    <button
                        class="ml-1"
                        (click)="addServiceUser()"
                        mat-flat-button
                        type="submit"
                        [color]="'primary'"
                        [disabled]="!formEnabled"
                    >
                        @if (formEnabled) {
                        <span> {{ 'label_register' | translate }} </span>
                        } @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </div>
        </div>
    </form>
</span>
